module.exports = new __parcel__URL__("frostportal.aed2f56f.png").toString();